<template>
  <div class="me">
    <van-contact-card
      type="edit"
      :name="userinfo.nickName"
      :tel="userinfo.account"
      :editable="false"
    />
    <div class="logout">
      <el-button class="logout_btn" type="primary" @click="handleLogoutBtnClick"
        >退出登录</el-button
      >
    </div>
  </div>
</template>

<script>
import getOwnDetails from "@/maintain/api/user/maintenance-man/getOwnDetails";
import router from "@/maintain/router";
import TokenStore from "@/utils/tokenStore";
import { Dialog } from "vant";

export default {
  name: "Me",
  data() {
    return {
      userinfo: {},
    };
  },
  created() {
    this.getmaintainUserInfo();
  },
  methods: {
    getmaintainUserInfo() {
      getOwnDetails().then((res) => {
        this.userinfo = res.data;
      });
    },
    handleLogoutBtnClick() {
      Dialog.confirm({
        title: "确定退出登录?",
        message: "",
      })
        .then(() => {
          TokenStore.removeToken("maintain");
          router.push({
            name: "登录",
            query: { redirect: window.location.pathname },
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.me {
  .logout {
    margin-top: 25px;
    width: 100%;
    text-align: center;
    .logout_btn {
      width: 95%;
    }
  }
}
</style>
